import { LegalLayout, H2, P, LI } from "@/components/site/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" effectiveDate="July 12, 2026">
      <P>
        At KIS Living, we value your trust and are committed to protecting your personal information.
        This Privacy Policy outlines how we collect, use, and secure your data when you interact with
        our site and our AI Travel Curator.
      </P>

      <H2>A. Information We Collect</H2>
      <P>To provide a smooth, personalized "Travel Genie" experience, we collect the following information:</P>
      <ul className="space-y-2">
        <LI><strong className="text-ink">Personal Identifiers:</strong> Name, email address, phone number, and physical mailing address (for shop shipping and booking confirmations).</LI>
        <LI><strong className="text-ink">Travel Details:</strong> Legal names of all travelers in your party, travel dates, and destination preferences required to issue official resort guest certificates.</LI>
        <LI><strong className="text-ink">Payment Information:</strong> Financial transactions are processed securely via third-party encryption gateways (e.g., Stripe, PayPal). KIS Living never stores your full credit card details or bank information on our servers.</LI>
      </ul>

      <H2>B. How We Use Your Information</H2>
      <P>We use your personal data to:</P>
      <ul className="space-y-2">
        <LI>Fulfill orders from the KIS Living Shop.</LI>
        <LI>Process and verify travel bookings with timeshare networks and resort properties.</LI>
        <LI>Power our AI Travel Curator to answer your emails, draft personalized travel guides, and provide tailored recommendations.</LI>
      </ul>

      <H2>C. Data Processing by AI</H2>
      <ul className="space-y-2">
        <LI><strong className="text-ink">Interaction Data:</strong> Correspondence sent to our email or input into our booking forms is processed by an automated AI assistant to streamline your customer service experience.</LI>
        <LI><strong className="text-ink">No Data Selling:</strong> KIS Living will never sell, rent, or lease your personal travel habits, email conversations, or contact information to third-party advertisers or brokers. Your data is strictly used to facilitate your specific KIS Living experience.</LI>
      </ul>

      <H2>D. Third-Party Sharing</H2>
      <P>We only share your information with third parties in the following strictly necessary scenarios:</P>
      <ul className="space-y-2">
        <LI><strong className="text-ink">Resort Operators:</strong> Providing your legal name to the timeshare company/resort to secure your check-in.</LI>
        <LI><strong className="text-ink">Payment Processors:</strong> Sending transaction details to secure payment gateways to process your fees.</LI>
        <LI><strong className="text-ink">Legal Requirements:</strong> If required by law, regulation, or a secure governmental request to protect the safety and rights of our club.</LI>
      </ul>

      <H2>E. Security Measures</H2>
      <P>
        We implement standard Secure Sockets Layer (SSL) encryption protocol to protect your data
        during transmission. Access to member accounts, personal booking history, and family travel
        schedules is password-protected and restricted from public search engines.
      </P>
    </LegalLayout>
  );
}
